import React from "react";
import { Outlet } from "react-router";
import { Header } from "../../components/LandingPage/Header";
import { Footer } from "../../components/LandingPage/Footer";
import Navbar from "../../components/AnimatedLandingPage/Navbar";

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      {/* <Header topbar2={true} /> */}
      <Outlet />
      <Footer />
    </div>
  );
};

export default LandingPage;
